"use client"
import { Button } from "@/components/atoms/Button/button"
import { Filter } from "lucide-react"
import { useFilterStore } from "@/stores/filterStore"
import useLocaleStore from "@/app/stores/useLocaleStore"

export const HideFilters = () => {
  const { set, status } = useFilterStore((s) => s)
  const lang = useLocaleStore().locale

  return (
    <Button
      onClick={() => {
        if (status === "hidden") {
          set("visible")
          return
        }

        set("hidden")
      }}
      className="hidden items-center gap-2 bg-transparent text-base font-thin text-black transition-colors dark:text-gray-200 lg:flex"
    >
      <span>{status === "hidden" ? (lang === "am" ? "ማጥአሪያውን አሳይ" : "Show Filters") : (lang === "am" ? "ማጣሪያውን አጥፋ" : "Hide Filters")}</span>
      <Filter />
    </Button>
  )
}
